import { render, staticRenderFns } from "./EntitlementsObligations.vue?vue&type=template&id=0fe662ba&scoped=true&"
import script from "./EntitlementsObligations.vue?vue&type=script&lang=js&"
export * from "./EntitlementsObligations.vue?vue&type=script&lang=js&"
import style0 from "./EntitlementsObligations.vue?vue&type=style&index=0&id=0fe662ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe662ba",
  null
  
)

export default component.exports